import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Box, Typography, Avatar } from "@mui/material";
import styles from "./HeaderStyles";

const Header: React.FC = () => {
  const { user } = useAuth0();

  const userRolePath = process.env.REACT_APP_USER_ROLE_PATH as string;

  const userRole = user && user[userRolePath] ? user[userRolePath][0] : null;

  console.log(userRole);

  if (!user) {
    return null;
  }

  const { name, nickname } = user;

  return (
    <header style={styles.headerContainer}>
      <Box style={styles.spacer} />
      <Box style={styles.userContainer}>
        <Avatar style={styles.avatar}>{name?.charAt(0) ?? ""}</Avatar>
        <Box style={{ ...styles.userInfo, flexDirection: "column" }}>
          <Typography style={styles.userName}>{name}</Typography>
          <Typography style={styles.userTitle}>{userRole}</Typography>
        </Box>
      </Box>
    </header>
  );
};

export default Header;
